import { render, staticRenderFns } from "./FriboiTemplate.vue?vue&type=template&id=7239dd26&"
import script from "./FriboiTemplate.vue?vue&type=script&lang=js&"
export * from "./FriboiTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VScrollYReverseTransition})
